export const btgLogo = require('./logo/btg-logo.svg')
export const btgWhiteLogo = require('./logo/btg-logo-white.svg')
export const btgBlueLogo = require('./logo/btg-logo-blue.png')
export const backgroundImage = require('./background/front-page-background.png')
export const filterControlsIcon = require('./filterControls/filter-controls.svg')
export const saveCsvIcon = require('./filterControls/save-csv.svg')
export const saveXlsxIcon = require('./filterControls/save-xlsx.svg')
export const restoreLayoutButton = require('./filterControls/restore-layout.svg')
